var TabMaintenanceModule = /** @class */ (function () {
    function TabMaintenanceModule() {
    }
    return TabMaintenanceModule;
}());
export { TabMaintenanceModule };
